import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import CreateExpCommercialInv from '../CreateForm/CreateExpCommercialInv';
import UpdateExpCommercialInv from '../UpdateForm/UpdateExpCommercialInv';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import { LIST_COMMERCIAL_INVOICES_EXPORT, GET_PRODUCTS_LIST, GET_SUPPLIERS_LIST, DELETE_COMMERCIAL_INVOICE_EXPORT, LIST_PROFORMA_INVOICES_EXPORT, LIST_IMPORT_SHIPPING_BOOKINGS } from '../../../services/apiRoutes';
import { genericPost } from '../../../services/authServices';
import axios from 'axios';
import CommercialInvoiceView from '../ViewDetails/CommercialInvoiceView';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import { getCommanExportShipmentId, getCurrencyList, getPortMasters, getRoundAmount } from '../../../services/CommonServices';
import CustomStatus from '../../common/CustomStatus';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";


const CommercialInvoice = ({ fetchButtonList }) => {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = useState('Commercial Invoice');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState({ open: false, text: '', type: '' });
    const [commercialInvExpId, setCommercialInvExpId] = useState('');
    const [customerList, setCustomerList] = useState([]);
    const [products, setProducts] = useState([]);
    const [viewModal, setViewModal] = useState(false);
    const [newShippingId, setNewShippingId] = useState(null);
    const [currencyList, setCurrencyList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [proformaInvoiceList, setProformaInvoiceList] = useState([]);
    const [qtyTotalproforma, setQtyTotalproforma] = useState([]);
    const [qtyTotalCommercial, setQtyTotalCommercial] = useState([]);
    const [portMasters, setPortMasters] = useState([]);
    const [bookingList, setBookingList] = useState([]);

    const navigate = useNavigate();
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);

    let customerId, cifFob;
    const hasFetched = useRef(false);
    useEffect(() => {
        if (shipmentDetails) {
            customerId = shipmentDetails.customerId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            getCommonData();
            fetchData();
            fetchProductsList();
            getCustomersList();
            getProformaInvoice();
            bookingfetchData();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, commercialInvExpId, token, deleteAlert, modal]);


    const getProformaInvoice = async () => {
        try {
            const payload = {
                customerNamesId: customerName,
                shipmentId: shipmentId
            };

            const response = await genericPost(LIST_PROFORMA_INVOICES_EXPORT, payload, {});

            if (response.data && response.data.success && response.data.data) {
                let totalQty = 0;

                const proform = response.data.data.map((invoice) => {
                    const particulars = invoice.particulars.map((particular) => {
                        const qty = Number(particular.qty) || 0;
                        totalQty += qty;
                        return {
                            qty,
                            particularName: particular.particularName || '',
                            description: particular.description || '',
                            rate: particular.rate || '',
                            amount: particular.amount || '',
                            productName: particular.products?.productName || '',
                            unit: particular.unit || ''
                        };
                    });

                    return {
                        id: invoice.proformaInvExpId || '',
                        title: `${expProformaPrefix || ''} ${invoice.proformaInvoiceNo || ''} ${expProformaSuffix || ''}`,
                        reference: invoice.reference || '',
                        dueDate: invoice.dueDate || '',
                        note: invoice.note || '',
                        particulars
                    };
                });

                setProformaInvoiceList(proform);
                setQtyTotalproforma(totalQty);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching suppliers list:', error);
            return [];
        }
    };


    const fetchProductsList = async () => {
        const authToken = sessionStorage.getItem('accessToken');
        const payload = {
            clientCompanyId: customerId,
        };

        try {
            const response = await axios.post(GET_PRODUCTS_LIST, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200 && response.data.success) {
                const productData = response.data.productsList;
                console.log(productData);
                setProducts(productData);
            } else {
                console.error('Failed to fetch products list:', response.data);
            }
        } catch (error) {
            console.error('Error fetching products list:', error);
        }
    };


    const getCustomersList = async () => {
        try {
            const payload = {
                clientCompanyId: customerId,
            };
            const response = await genericPost(GET_SUPPLIERS_LIST, payload, {
            });
            if (response.data && response.data.success && response.data.clientCompanies) {
                const customersData = response.data.clientCompanies.map((customer) => ({
                    id: customer.clientCompanyId,
                    title: customer.clientCompanyName,
                }));
                setCustomerList(customersData);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching customer list:', error);
            return [];
        }
    };
    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
        const getPortMastersData = await getPortMasters()
        setPortMasters(getPortMastersData)
    }

    const bookingfetchData = async () => {
        setLoading(true);

        try {
            const payload = {
                clientCompanyId: customerId,
                commanShipmentId: getCommanExportShipmentId,
                shipmentId: shipmentId,
            };

            const response = await genericPost(
                LIST_IMPORT_SHIPPING_BOOKINGS,
                payload
            );

            if (response.data.success && response.data.shippingBooking) {

                const shippingBookingData = response.data.shippingBooking.map((booking) => ({
                    id: booking.shippingBookingId || "",
                    title: booking.bookingNumber || "",
                }));

                setBookingList(shippingBookingData);

            } else {
                setBookingList([]);
                setError("No shipping bookings found");
            }
        } catch (error) {
            setBookingList([]);
            setError("Error fetching shipping bookings");
            console.error("Error fetching shipping bookings", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                customerNamesId: customerId,
                shipmentId: shipmentId,
            };
            const response = await genericPost(LIST_COMMERCIAL_INVOICES_EXPORT, payload);
            if (response.data.success) {
                let totalQtyAcrossInvoices = 0;
                const commercialInvoices = response.data.data.map((invoice, index) => {
                    const particulars = invoice.particulars.map((particular) => ({
                        qty: parseFloat(particular.qty || 0),
                        rate: parseFloat(particular.rate) || 0,
                        amount: (particular.qty || 0) * (parseFloat(particular.rate) || 0),
                    }));
                    const totalAmount = getRoundAmount(particulars.reduce((total, { amount }) => total + amount, 0));

                    const totalQty = particulars.reduce((total, { qty }) => total + qty, 0);
                    totalQtyAcrossInvoices += totalQty;

                    return {
                        commercialInvExpId: invoice.commercialInvExpId || '',
                        index: (index + 1).toString().padStart(2, '0'),
                        userId: invoice.userId || '',
                        companyId: invoice.companyId || '',
                        customerName: invoice.customer.clientCompanyName || '',
                        bookingNumber: invoice.booking?.bookingNumber || '',
                        country: invoice.customer.billingCountry.name || '',
                        reference: invoice.reference || '',
                        commercialInvoiceNo: `${expCommercialPrefix || ''} ${invoice.commercialInvoiceNo || ''} ${expCommercialSuffix || ''}`,
                        dueDate: companyDateFormat(invoice?.dueDate) || '',
                        date: companyDateFormat(invoice?.date) || '',
                        note: invoice.note || '',
                        createdAt: invoice.createdAt || '',
                        updatedAt: invoice.updatedAt || '',
                        particulars,
                        totalAmount: `${invoice.currency?.currency_symbol || ''} ${totalAmount ? totalAmount.toFixed(2) : ""}`,
                        shipmentIdName: shipmentId || '',
                        // totalQty: totalQty || '',
                        totalQty: totalQty ? totalQty.toFixed(2) : "",
                        qtyStatus: qtyTotalproforma || '',
                    };
                });
                const { newShippingId } = response.data;
                setNewShippingId(newShippingId);
                setData(commercialInvoices);
                setQtyTotalCommercial(totalQtyAcrossInvoices);

            } else {
                setError('No commercial invoices found');
            }
        } catch (error) {
            setError('Error fetching commercial invoices');
            console.error('Error fetching commercial invoices', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (commercialInvExpId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_COMMERCIAL_INVOICE_EXPORT(commercialInvExpId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
                fetchButtonList();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    // Table columns
    const columns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'commercialInvoiceNo', label: 'Commercial Invoice No.', accessor: 'commercialInvoiceNo', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'bookingNumber', label: 'Booking Number', accessor: 'bookingNumber', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'shipmentIdName', label: 'Shipping Id', accessor: 'shipmentIdName', styleAccessor: {
                textAlign: 'center',
            },
        },
        { id: 'customerName', label: 'Customer Name', accessor: 'customerName' },
        {
            id: 'totalAmount', label: 'Amount', accessor: 'totalAmount', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'totalQty', label: 'total Qty', accessor: 'totalQty', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'qtyStatus',
            label: 'Qty Status',
            accessor: 'qtyStatus',
            Cell: ({ row }) => {
                const proforma = parseFloat(qtyTotalproforma) || 0;
                const commercial = parseFloat(qtyTotalCommercial) || 0;
                const qtyUpdated = proforma - commercial;
                const statusText = qtyUpdated > 0 ? 'Partial' : 'Complete';
                const statusStyles = statusText === 'Complete'
                    ? { backgroundColor: '#e9ffe3', color: '#0a2d00', border: '1px solid #0a2d00' }
                    : { backgroundColor: '#FFD7E9', color: '#41001d', border: '1px solid #41001d' };
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CustomStatus
                            title={statusText}
                            sx={{
                                textAlign: 'center',
                                display: 'inline-block',
                                ...statusStyles,
                            }}
                        />
                    </div>
                );
            },
            styleAccessor: { textAlign: 'center' },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.commercialInvExpId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.commercialInvExpId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.commercialInvExpId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];


    const handleUpdateClick = (id) => {
        setCommercialInvExpId(id);
        setUpdateModal(true);
    };

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setCommercialInvExpId('');
    };
    const handleViewClick = (id) => {
        setCommercialInvExpId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setCommercialInvExpId('');
    };


    if (!shipmentDetails) {
        return <p>    <CustomLoader open={shipmentLoading} /> </p>;
    }

    const companyName = shipmentDetails.customer.clientCompanyName;
    const phoneNumber = shipmentDetails.customer.mobile;
    const customerName = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const currencySymbol = shipmentDetails?.currency?.currency_symbol ?? '';
    const currencyShort = shipmentDetails?.currency?.currency ?? '';
    const currencyId = shipmentDetails?.currency?.id ?? '';
    const shipmentOrgId = shipmentDetails.exportShipmentId;
    const expCommercialPrefixActivity = shipmentDetails.company.expCommercialPrefixActivity ?? '';
    const expCommercialPrefix = (expCommercialPrefixActivity === 1)
        ? shipmentDetails.company.expCommercialPrefix
        : (expCommercialPrefixActivity === 0 ? '' : '');

    const expCommercialSuffixActivity = shipmentDetails.company.expCommercialSuffixActivity ?? '';
    const expCommercialSuffix = (expCommercialSuffixActivity === 1)
        ? shipmentDetails.company.expCommercialSuffix
        : (expCommercialSuffixActivity === 0 ? '' : '');

    const expProformaPrefixActivity = shipmentDetails.company.expProformaPrefixActivity ?? '';
    const expProformaPrefix = (expProformaPrefixActivity === 1)
        ? shipmentDetails.company.expProformaPrefix
        : (expProformaPrefixActivity === 0 ? '' : '');

    const expProformaSuffixActivity = shipmentDetails.company.expProformaSuffixActivity ?? '';
    const expProformaSuffix = (expProformaSuffixActivity === 1)
        ? shipmentDetails.company.expProformaSuffix
        : (expProformaSuffixActivity === 0 ? '' : '');

    const templateId = shipmentDetails?.company?.templateId ?? '1';

    const proforma = parseFloat(qtyTotalproforma) || 0;
    const commercial = parseFloat(qtyTotalCommercial) || 0;
    const qtyUpdated = proforma - commercial;
    const portOfLoading = shipmentDetails?.portOfLoading ?? '';
    const portOfDestination = shipmentDetails?.portOfDestination ?? '';

    const statusText = qtyUpdated > 0 ? 'Partial' : 'Complete';


    return (
        <div>
            <CustomLoader open={loading} />
            <DetailsPageCard
                columns={columns}
                title="Commercial Invoice"
                buttonTitle="Create Commercial Invoice"
                // buttonTitle={statusText === "Complete" ? undefined : "Create Commercial Invoice"}
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}

            />
            <CustomModal open={modal}  >
                <CreateExpCommercialInv
                    fetchData={fetchData}
                    customerList={customerList}
                    productsList={products}
                    customerName={customerName}
                    newShippingId={newShippingId}
                    shipmentId={shipmentId}
                    shipmentOrgId={shipmentOrgId}
                    setMessage={setMessage}
                    currencyList={currencyList}
                    currencyId={currencyId}
                    currencySymbol={currencySymbol}
                    expCommercialPrefix={expCommercialPrefix}
                    expCommercialSuffix={expCommercialSuffix}
                    expProformaPrefix={expProformaPrefix}
                    expProformaSuffix={expProformaSuffix}
                    qtyUpdated={qtyUpdated}
                    fetchButtonList={fetchButtonList}
                    portOfLoading={portOfLoading}
                    portOfDestination={portOfDestination}
                    portMasters={portMasters}
                    handleClose={handleClose}
                    bookingList={bookingList}
                />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdateExpCommercialInv
                    fetchData={fetchData}
                    customerList={customerList}
                    productsList={products}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    commercialInvExpId={commercialInvExpId}
                    currencyList={currencyList}
                    expCommercialPrefix={expCommercialPrefix}
                    expCommercialSuffix={expCommercialSuffix}
                    expProformaPrefix={expProformaPrefix}
                    expProformaSuffix={expProformaSuffix}
                    portMasters={portMasters}
                    bookingList={bookingList}
                />
            </CustomModal>
            <CustomModal open={viewModal} handleClose={handleCloseView}>
                <CommercialInvoiceView
                    fetchData={fetchData}
                    companyName={companyName}
                    phoneNumber={phoneNumber}
                    customerList={customerList}
                    productsList={products}
                    setMessage={setMessage}
                    handleClose={handleCloseView}
                    commercialInvExpId={commercialInvExpId}
                    expCommercialPrefix={expCommercialPrefix}
                    expCommercialSuffix={expCommercialSuffix}
                    expProformaPrefix={expProformaPrefix}
                    expProformaSuffix={expProformaSuffix}
                    templateId={templateId}
                    shipmentOrgId={shipmentOrgId}
                />
            </CustomModal>

            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
};

export default CommercialInvoice;
